import { apiCall, ApiResponse } from "./apiClient";
import { TransportOrderNotificationDto, TransportOrderNotificationListItemDto, TransportOrderNotificationListQueryParameters } from "../models/transport/transportOrderNotification";

export const getTransportOrderNotifications = (qsp: TransportOrderNotificationListQueryParameters): Promise<ApiResponse<TransportOrderNotificationListItemDto[]>> => {
    return apiCall<TransportOrderNotificationListItemDto[]>("TransportOrderNotifications/notifications", "GET", qsp);
};

export const confirmTransportOrderNotification = (transportOrderNotificationId: string): Promise<ApiResponse<TransportOrderNotificationDto>> => {
    return apiCall<TransportOrderNotificationDto>(`TransportOrderNotifications/${transportOrderNotificationId}/confirm`, "PUT");
};

export const confirmDesktopToMobileNotifications = async(
    transportOrderId: string,
    employeeId: string
): Promise<TransportOrderNotificationListItemDto[]> => {
    const response = await apiCall<TransportOrderNotificationListItemDto[]>(
        `TransportOrderNotifications/confirm-desktop/${transportOrderId}?employeeId=${employeeId}`,
        "POST"
    );
    return response.data;
};
